<template>
    <div class="mark">
        <div class="topBox">
            <div class="title">上传文件</div>
            <div class="firBox">
                <div class="mtitle">文件类型</div>
                <div class="rcontent">
                    <el-select v-model="bTypeVal" placeholder="请选择" @change="checkBVal">
                        <el-option v-for="item in bTypeList" :key="item.num" :label="item.name" :value="item.name">
                            <span style="text-align: center;color: #8492a6; font-size: 13px">{{ item.name }}</span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin-top: 20px;display: flex;justify-content: center;align-items: center;">
                <div class="uploadBox">
                    <el-upload class="upload-demo" :auto-upload="false" drag :on-change="handleChange" multiple
                        action="" :file-list="fileList" ref="uploader" :limit="20" :on-exceed="handleExceed">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">上传的照片最大尺寸设置为10MB，视频为50MB</div>
                    </el-upload>
                    <el-button class="submitBtn" type="primary" @click="sendUpload"
                        :loading="uploadLoading">上传</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uploadImage, getUploadImage, uploadVideo, uploadAudio } from '@/api/talkytimes/message'
export default {
    name: 'uploadMark',
    props: {
        uploadShow: {
            type: Boolean,
            default: false
        },
        platformType: {
            type: String,
            default: 'talkytimes'
        },
        platformUserId: {
            type: [String, Number],
            default: null
        },
        userId: {
            type: [String, Number],
            default: null
        },
        initialFileType: {
            type: String,
            default: '图片'
        },
    },
    components: {},
    data() {
        return {
            bTypeList: [{
                name: '图片',
                num: 1
            }, {
                name: '视频',
                num: 2
            }, {
                name: '音频',
                num: 3
            }],
            bTypeVal: '',
            myUserInfo: '',
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            upBType: '',
            imageUrl: [],
            fileList: [],
            uploadLoading: false
        };
    },
    computed: {
    },
    watch: {
        initialFileType: {
            handler(newVal) {
                console.log('initialFileType changed to:', newVal)
                if (newVal) {
                    this.bTypeVal = newVal;
                    this.checkBVal(newVal);
                }
            },
            immediate: true
        }
    },
    methods: {
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        checkBVal(t) {
            console.log('checkBVal called with:', t)
            this.fileList = []
            if (this.$refs.uploader) {
                this.$refs.uploader.clearFiles();
            }
            this.upBType = ''

            if (t === '图片') {
                console.log('设置图片类型')
                this.upBType = 1
            } else if (t === '视频') {
                console.log('设置视频类型')
                this.upBType = 2
            } else if (t === '音频') {
                console.log('设置音频类型')
                this.upBType = 3
            }
            console.log('upBType set to:', this.upBType)
        },

        handlePreview(file) {
            console.log(file);
        },
        handlePictureCardPreview(file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        handleChange(file, fileList) {
            this.fileList = fileList;
            if (!this.upBType) {
                this.$message.error('请先选择文件类型');
                this.fileList.splice(this.fileList.indexOf(file), 1);
                return;
            }

            fileList.every(file => {
                const isImage = file.raw.type.startsWith('image/');
                const isVideo = file.raw.type.startsWith('video/');
                const isAudio = file.raw.type.startsWith('audio/');

                if (this.upBType == 1) {
                    if (!isImage) {
                        this.$message.error(`请上传图片`);
                        this.fileList.splice(this.fileList.indexOf(file), 1);
                        return false;
                    }
                    if (file.size > 10 * 1024 * 1024) {
                        this.fileList.splice(this.fileList.indexOf(file), 1);
                        this.$message.error(`文件 ${file.name} 大小不能超过10M`);
                        return false;
                    }

                } else if (this.upBType == 2) {
                    if (!isVideo) {
                        this.$message.error(`请上传视频`);
                        this.fileList.splice(this.fileList.indexOf(file), 1);
                        return false;
                    }
                    if (file.size > 50 * 1024 * 1024) {
                        this.$message.error(`文件 ${file.name} 大小不能超过50M`);
                        this.fileList.splice(this.fileList.indexOf(file), 1);
                        return false;
                    }

                } else if (this.upBType == 3) {
                    if (!isAudio) {
                        this.$message.error(`请上传音频`);
                        this.fileList.splice(this.fileList.indexOf(file), 1);
                        return false;
                    }
                }
                return true; // 文件合法
            });
        },
        sendUpload() {
            if (this.fileList.length === 0) {
                this.$message.error('请选择要上传的文件');
                return;
            }

            if (!this.upBType) {
                this.$message.error('请先选择文件类型');
                return;
            }

            this.uploadLoading = true;

            // 逐个上传文件
            const uploadPromises = this.fileList.map(file => this.uploadSingleFile(file));

            Promise.all(uploadPromises).then(results => {
                this.uploadLoading = false;
                this.$refs.uploader.clearFiles();
                this.$message.success('上传成功');
                this.$emit('upload-close', { son: true });
                this.$emit('uploadComplete');
            }).catch(error => {
                this.uploadLoading = false;
                this.$refs.uploader.clearFiles();
                this.$message.error('上传失败: ' + error.message);
            });
        },

        async uploadSingleFile(file) {

            try {
                console.log('uploadSingleFile:', file, this.upBType);
                if (this.upBType == 1) {
                    // 图片上传
                    return await this.uploadImageFile(file);
                } else if (this.upBType == 2) {
                    // 视频上传
                    return await this.uploadVideoFile(file);
                } else if (this.upBType == 3) {
                    // 音频上传
                    return await this.uploadAudioFile(file);
                }
            } catch (error) {
                console.error('文件上传失败:', error);
                throw error;
            }
        },

        async uploadImageFile(file) {
            // 第一步：上传文件到临时服务器
            console.log('uploadImageFile:', file);
            const formData = new FormData();
            formData.append('file', file.raw);

            const uploadResponse = await uploadImage(formData);
            console.log('uploadImageFile:', uploadResponse);
            if (!uploadResponse.key) {
                throw new Error('上传失败，未获取到文件key');
            }

            // 第二步：将文件信息提交到后台
            const fileInfo = {
                key: uploadResponse.key
            };

            const finalResponse = await getUploadImage(fileInfo);
            console.log('uploadImageFile:', finalResponse);
            if (!finalResponse.idPhoto) {
                throw new Error(finalResponse.error || '图片上传失败');
            }

            return finalResponse;
        },

        async uploadVideoFile(file) {
            // 使用uploadVideo函数处理视频上传
            const formData = new FormData();
            formData.append('file', file.raw);

            const uploadResponse = await uploadVideo(formData);

            if (!uploadResponse.success) {
                throw new Error(uploadResponse.error || '视频上传失败');
            }

            return uploadResponse;
        },

        async uploadAudioFile(file) {
            // 使用uploadAudio函数处理音频上传
            const formData = new FormData();
            formData.append('file', file.raw);

            // 获取用户ID，优先使用 platformUserId，如果没有则从 localStorage 获取
            let idUser = this.platformUserId;
            if (!idUser) {
                const activeUserStr = localStorage.getItem('activeUser');
                if (activeUserStr) {
                    const activeUser = JSON.parse(activeUserStr);
                    idUser = activeUser.id || activeUser.platformUserId;
                }
            }

            if (!idUser) {
                throw new Error('缺少用户ID');
            }

            const uploadResponse = await uploadAudio(formData, idUser);

            if (!uploadResponse.success) {
                throw new Error(uploadResponse.error || '音频上传失败');
            }

            return uploadResponse;
        },

        uploadComplete() {
            this.uploadLoading = false;
            this.$emit('uploadComplete');
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.mark {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .topBox {
        padding-top: 30px;
        width: 80%;

        .title {
            font-weight: 600;
            font-size: 24px;
            text-align: center;
        }

        .firBox {
            width: 100%;
            margin-top: 40px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid #E4F3FF;

            .mtitle {
                width: 100px;
                height: 40px;
                background-color: #2499FF;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            .rcontent {
                flex: 1;

                ::v-deep .el-select {
                    width: 100%;

                    .el-input__inner {
                        border: none;
                    }
                }

                ::v-deep .el-input__inner {
                    border: none;
                }
            }
        }
    }
}

.uploadBox {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.submitBtn {
    width: 100px;
    margin-top: 10px;
}

:deep(.el-upload-list--text) {
    max-height: calc(80vh - 400px) !important;
    overflow-y: scroll !important;
}
</style>